const CodexTierLogoDiamond = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 105 105">
    <path
      fill="#f4511e"
      d="M0,52.5  L52.5,0 L105,52.5 L52.5,105 L0,52.5 Z M52.5,52.5"
    />
  </svg>
);

export default CodexTierLogoDiamond;
